import { Modal, Title } from "@mantine/core";
import { useState } from "react";
import {
  Collab,
  ContentSubmissionItem,
} from "../../../../../../gql/__generated__/graphql";
import SubmitContentForm from "./SubmitContentForm";

interface SubmitContentModalProps {
  opened: boolean;
  onClose: () => void;
  collab: Collab;
  onSubmit: (data: {
    contentItems: ContentSubmissionItem[];
    message?: string;
  }) => Promise<void>;
}

function SubmitContentModal(props: SubmitContentModalProps) {
  const videoRequirement = props.collab.requirements.find(
    (req) => req.type.toLowerCase() === "video"
  );
  const numberOfVideos = videoRequirement ? videoRequirement.quantity : 0;

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data: {
    contentItems: ContentSubmissionItem[];
    message?: string;
  }) => {
    setIsSubmitting(true);
    try {
      await props.onSubmit(data);
      // If successful, the parent will close the modal
    } catch (error) {
      // Parent will show error, and we should re-enable the form
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (!isSubmitting) {
      props.onClose();
    }
  };

  if (numberOfVideos === 0) {
    return null;
  }

  return (
    <Modal
      opened={props.opened}
      onClose={handleClose}
      title={<Title order={3}>Submit Content</Title>}
      size="md"
      centered
    >
      <SubmitContentForm
        numberOfVideos={numberOfVideos}
        onSubmit={handleSubmit}
        onCancel={handleClose}
        isLoading={isSubmitting}
      />
    </Modal>
  );
}

export default SubmitContentModal;
